import { TSwitchLabelPosition, TSwitchProps, TSwitchSize, TSwitchType } from './Switch.type';
import { HTMLInputTypeAttribute } from 'react';

export const SWITCH_SIZES: TSwitchSize[] = ['sm', 'md', 'lg'];
export const SWITCH_SIZE: { [key in TSwitchSize]: key } = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};

export const SWITCH_TYPES: TSwitchType[] = ['single', 'multiple'];
export const SWITCH_TYPE: { [key in TSwitchType]: key } = {
  single: 'single',
  multiple: 'multiple'
};

export const INPUT_TYPE: { [key in Extract<HTMLInputTypeAttribute, 'checkbox' | 'radio'>]: key } = {
  checkbox: 'checkbox',
  radio: 'radio'
};

export const SWITCH_LABEL_POSITIONS: TSwitchLabelPosition[] = ['left', 'right'];
export const SWITCH_LABEL_POSITION: { [key in TSwitchLabelPosition]: key } = {
  left: 'left',
  right: 'right'
};

export const SWITCH_DEFAULT_PROPS: TSwitchProps = {
  labelPosition: SWITCH_LABEL_POSITION.right,
  size: SWITCH_SIZE.md,
  type: SWITCH_TYPE.multiple
};
